import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock, OriginalAndStandardFactBlock } from '../../commonComponents/CommonComponents'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function HolocaustMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId
  const personSummary = queueCachesState.personsCache[personId]
  const personLabels = queueCachesState.labelsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]
  let personSourcesCount
  if (!personSummary || (personSummary && Object.keys(personSummary).length === 0)) {
    personSourcesCount = '?'
  } else {
    personSourcesCount =
      personSummary?.entityReferenceTypeSummaries?.find((entity) => entity.type === 'SOURCE')?.refs?.length || 0
  }

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchPersonLabels(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(personLabels) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab="treePersonTab" />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('sourceCount', 'Sources: {sources}', { sources: personSourcesCount })} />
      </Cell>
      <TreeIdCells treeId={personSummary?.summary?.treeId} isResearcherTree={personSummary?.summary?.researcherTree} />

      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('birth', 'Birth')} fact={personSummary?.birth} columns={6} />

      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('death', 'Death')} fact={personSummary?.death} columns={6} />

      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('burial', 'Burial')} fact={personSummary?.burial} columns={6} />

      {/* Row */}
      <LabelsBlock personLabels={personLabels} />
    </Grid>
  )
}
